<template>
  <div>
    <div class="ma-6">
      <v-tabs
        color="white"
        background-color="transparent"
        hide-slider
        v-model="tab"
      >
        <v-tab :class="tab == 0 ? 'active' : 'non_active'">Internship</v-tab>
        <v-tab :class="tab == 1 ? 'active' : 'non_active'">Sponsorship</v-tab>
        <v-tab :class="tab == 2 ? 'active' : 'non_active'">GEP</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" style="background: none">
        <v-tab-item class="pb-3">
          <profile-proposal-internship-scholar />
        </v-tab-item>
        <v-tab-item class="pb-3">
          <profile-proposal-sponsorship-scholar />
        </v-tab-item>
        <v-tab-item class="pb-3">
          <profile-proposal-gep-scholar />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import ProfileProposalGepScholar from "./profileProposalGepSchola.vue";
import ProfileProposalInternshipScholar from "./profileProposalInternshipScholar.vue";
import ProfileProposalSponsorshipScholar from "./profileProposalSponsorshipScholar.vue";
export default {
  name: "proposalScholar",
  components: {
    ProfileProposalSponsorshipScholar,
    ProfileProposalInternshipScholar,
    ProfileProposalGepScholar,
  },
  data() {
    return {
      tab: null,
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped>
.v-pagination__item {
  box-shadow: none !important;
}
.v-pagination__navigation {
  box-shadow: none !important;
}
.active {
  border-radius: 10px 10px 0 0;
  background: #006341;

  text-transform: capitalize;
  font-weight: bold;
}
.non_active {
  border-radius: 10px 10px 0 0;
  background: white;
  text-transform: capitalize;
}
.input_green {
  border: 2px solid var(--g);
  border-radius: 5px;
  padding: 0 0 0 30px;
  height: 38px;
  background: #fff;
  width: 100%;
}
.input_green:focus {
  outline: none;
}
.magnify {
  margin-right: -30px;
}
</style>
